<!-- 微博-开发者账户管理 -->
<template>
<div>
	<!-- 表头 -->
	<div class="table-th" :style="{'width': table_scroll_width_c - 60 + 'px'}">
		
		<div  v-for="(item,index) in rableTitle" :key="index" >
			<div class="table-th-cell" 
			:style="{'width':item.width + 'px',}">
				{{item.title}}
			</div>
		</div>
	</div>
	
	<!-- 表格内容 -->
	<div v-for="(item,index) in ToutiaoList" :key="index" class="table-td"  :style="{'width': table_scroll_width_c -60 + 'px'}">
		<template v-for="(z_tem,z_ndex) in rableTitle">
			<div v-if="z_tem.type != 'appid' && z_tem.type != 'refresh_expires_in'" class="table-td-cell"
			 :class="{'text-right': rableTitle[z_ndex].text_right}"
			:style="{'width':rableTitle[z_ndex].width + 'px'}">
				{{item[z_tem.type]}}
			</div>
			<!-- 授权有效期 -->
			<div v-else-if="z_tem.type == 'refresh_expires_in'" class="table-td-cell"
			 :class="{'text-right': rableTitle[z_ndex].text_right}"
			:style="{'width':rableTitle[z_ndex].width + 'px'}">
				{{item[z_tem.type]}} <span v-if="item.refresh_expires_text" style="color: red;">（{{item.refresh_expires_text}}）</span>
			</div>
			<!-- 操作 -->
			<div v-else-if="z_tem.type == 'appid'" class="table-td-cell"
			 :class="{'text-right': rableTitle[z_ndex].text_right}"
			:style="{'width':rableTitle[z_ndex].width + 'px'}" >
				{{item[z_tem.type]}}
				<span @click="tdCz(item,1)" style="cursor: pointer;color: #62a8ea;margin-left: 7px;">授权</span>
			</div>
		</template>
	</div>
	
	<div v-show="ToutiaoList.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_scroll_width_c + 'px'}">
		<a-icon style="font-size: 70px;color: #999;" type="file-search" />
		
		<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
	</div>
	
	
</div>
</template>

<script>
import { accountWBDev, accountWBsync } from '@/request/api'
export default {
	name: 'wbDevPage_',
	data() {
		return {
			rableTitle: [
				{title:"开发者账户", width:100, type:"account_name", }, 
				{title:"APPID", width:120, type:"appid", },
				{title:"秘钥", width:150, type:"secret", },
				{title:"token", width:150, type:"refresh_token", },
				{title:"微博登陆账户", width:100, type:"account", },
				{title:"授权到期时间", width:120, type:"refresh_expires_in", },
			],
			tableShowDataBBB: [],
			table_scroll_width_c: 1000,
			ToutiaoList: [], // 开发者账户
			
		}
	},
	mounted(){
		let that = this
		// 获取表格信息
		let table_info_c = this.$getTableInfo(that.rableTitle)
		
		that.table_scroll_width_c = table_info_c.table_width
		
		// 开发者账户
		accountWBDev().then(res=>{
			console.log("开发者账户",res);
			if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
				let data = res.data.data.data
				data.forEach(res=>{
					if(res.refresh_expires_in){
						let date = new Date(res.refresh_expires_in)
						let ddd = date.getTime() - Date.now()
						if(ddd > 0 && ddd < 864000000){ // 相差10天内，表示快要过期
							res.refresh_expires_text = "快过期"
						}
						else if(date.getTime() - Date.now() <= 0){
							res.refresh_expires_text = "已过期"
						}
						else { // 表示还有日期，还不会过期
							res.refresh_expires_text = ""
						}
					}
					else {
						res.refresh_expires_text = null
					}
				})
				that.ToutiaoList = res.data.data.data
			}
			else {
				that.ToutiaoList = []
				that.$message.error(`代理商账户-错误：${res.data.msg}`);
			}
		})
		
		// that.searchButton()
	},
	methods:{
		// 搜索
		searchButton(type){
			let that = this
			
			// that.search_button_loading = true
			
			// if(type != '分页'){
			// 	that.selectedData = [] // 已选内容清空
			// }
			
			// if(type == 'button'){
			// 	that.r_page = 1
			// }
			
			
			// 开发者账户
			accountWBagent().then(res=>{
				console.log("开发者账户",res);
				// that.search_button_loading = false
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					that.ToutiaoList = res.data.data.data
				}
				else {
					that.ToutiaoList = []
					that.$message.error(`开发者账户-错误：${res.data.msg}`);
				}
			})
			
		},
		tdCz(item,type){
			let that = this
			// console.log("item",item)
			if(type == 1){
				console.log("跳转链接",`${that.$http.excel_url}api/weibo/oauth-scan?appid=${item.appid}`)
				window.open(`${that.$http.excel_url}api/weibo/oauth-scan?appid=${item.appid}`, '_blank');
			}
		},
		
	},
	filters: {
		// 计划状态
		jhStatusFilters(value){
			let vvv = ""
			if(value == -1){
				vvv = "结束状态"
			}
			else if(value == -99){ // 这个已废弃
				vvv = "删除"
			}
			else if(value == 0){
				vvv = "默认状态"
			}
			else if(value == 1){
				vvv = "待投放"
			}
			else if(value == 2){
				vvv = "投放中"
			}
			else if(value == 3){
				vvv = "用户暂停"
			}
			else if(value == 5){
				vvv = "账户异常"
			}
			else if(value == 6){
				vvv = "系列暂停"
			}
			else if(value == 7){
				vvv = "余额不足"
			}
			else if(value == 8){
				vvv = "到达账户日限额"
			}
			else if(value == 9){
				vvv = "到达系列预算"
			}
			else if(value == 10){
				vvv = "到达计划日限额"
			}
			else if(value == 11){
				vvv = "无可用创意"
			}
			else if(value == 12){
				vvv = "粉条订单创建中"
			}
			else if(value == 13){
				vvv = "数据市场包处理中"
			}
			else if(value == 14){
				vvv = "电子围栏生成失败"
			}
			return vvv
		},
	}
	
}
</script>
<style>
</style>